export default __webpack_public_path__ + "static/media/slider-img-2.4b1b99b3.png";